import { render, staticRenderFns } from "./PointSelector.vue?vue&type=template&id=b0559b02&scoped=true&"
import script from "./PointSelector.vue?vue&type=script&lang=js&"
export * from "./PointSelector.vue?vue&type=script&lang=js&"
import style0 from "./PointSelector.vue?vue&type=style&index=0&id=b0559b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0559b02",
  null
  
)

export default component.exports